import styled from 'styled-components';

export const HubStyled = styled.div<{
  selected: boolean;
  condensed: boolean;
  includesSubscription: boolean;
}>`
  position: relative;
  margin-bottom: 30px;
  background-color: ${({ theme }) => theme.colors.neutral0};
  display: flex;
  justify-content: center;

  transition: all 300ms ease;

  > div:first-child {
    background: linear-gradient(180deg, #f3f3f3 41.82%, #deff00 100%);

    border: ${({ theme }) => `1px solid ${theme.colors.primary900}`};
    border-radius: 24px;
    display: flex;
    flex-direction: column;
    align-items: center;
    transition: all 300ms ease;
    padding: 10px;
    text-align: center;
  }

  > div > div:nth-child(2) {
    /* width: 100%; */
    padding: 24px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 10px;
  }

  /* ${({ selected, theme }) =>
    selected &&
    `
      background-color: ${theme.colors.secondaryBlue};
    `} */

  @media (max-width: 800px) {
    /* background-color: ${({ theme }) => theme.colors.secondaryBlue}; */
    /* > div:first-child {
      background-color: ${({ theme }) => theme.colors.neutral0};
    } */

    /* > div > div:nth-child(2) {
      padding: 16px;

      > div:nth-child(1) {
        flex: none;
      }

      > div:nth-child(1) {
        width: 100%;
      }

      > div:nth-child(2) {
        display: none;
      }
    } */
  }

  ${({ condensed }) =>
    condensed &&
    `
    > div > div:nth-child(2) {
      padding: 16px;
      gap: 5px;
    }
  `}
`;

export const HubImage = styled.div<{ image: any; condensed: boolean }>`
  width: 200px;
  display: flex;
  flex-grow: 1;
  border-radius: 24px;
  flex: none;
  aspect-ratio: 1/1;
  background: url(${({ image }) => image});
  background-position: top center;
  background-size: cover;
  background-repeat: no-repeat;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-end;
  padding: 20px;

  @media (max-width: 800px) {
    width: 200px;
    height: 100%;
    aspect-ratio: 1/1;
    background-position: top center;
  }

  ${({ condensed }) =>
    condensed &&
    `
    width: 200px;
  `}
`;

export const HubArrow = styled.div`
  display: none;
  position: absolute;
  top: 16px;
  right: 16px;
  @media (max-width: 800px) {
    display: block;
  }
`;

export const Collapsable = styled.div<{
  expanded: boolean;
  elementHeight: number;
}>`
  display: none;
  opacity: ${(props) => (props.expanded ? '1' : '0')};
  visibility: ${(props) => (props.expanded ? 'visible' : 'hidden')};
  max-height: ${({ expanded, elementHeight }) =>
    expanded ? `${elementHeight}px` : '0px'};
  overflow: hidden;
  transition: all 300ms;

  @media (min-width: 3500px) {
    /* margin-top: ${(props) => (props.expanded ? '40px' : '0px')}; */
  }

  @media (max-width: 800px) {
    display: block;
    /* margin-top: ${(props) => (props.expanded ? '10px' : '0px')}; */
  }
`;
